export class Microsoft365User {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "userId",
            "baseName": "userId",
            "type": "string",
            "format": ""
        },
        {
            "name": "userPrincipalName",
            "baseName": "userPrincipalName",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "mail",
            "baseName": "mail",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountEnabled",
            "baseName": "accountEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "hasMailbox",
            "baseName": "hasMailbox",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "hasOnedrive",
            "baseName": "hasOnedrive",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "mailboxType",
            "baseName": "mailboxType",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365User.attributeTypeMap;
    }
    constructor() {
    }
}
